import { render } from "./Laporan.vue?vue&type=template&id=8beba6ec&scoped=true"
import script from "./Laporan.vue?vue&type=script&lang=js"
export * from "./Laporan.vue?vue&type=script&lang=js"

import "./Laporan.vue?vue&type=style&index=0&id=8beba6ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8beba6ec"]])

export default __exports__